import { render } from "./WindowDashboard.vue?vue&type=template&id=6f3a19eb&scoped=true"
import script from "./WindowDashboard.vue?vue&type=script&lang=js"
export * from "./WindowDashboard.vue?vue&type=script&lang=js"

import "./WindowDashboard.vue?vue&type=style&index=0&id=6f3a19eb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3a19eb"]])

export default __exports__